import { render, staticRenderFns } from "./MwSelectAndOrder.vue?vue&type=template&id=5c1798d6&scoped=true&"
import script from "./MwSelectAndOrder.vue?vue&type=script&lang=js&"
export * from "./MwSelectAndOrder.vue?vue&type=script&lang=js&"
import style0 from "./MwSelectAndOrder.vue?vue&type=style&index=0&id=5c1798d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1798d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VRow,VSimpleTable})
